import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AllFormsComponent } from './admin/all-forms/all-forms.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { ViewFormComponent } from './admin/view-form/view-form.component';
import { ViewSubmissionsComponent } from './admin/view-submissions/view-submissions.component';
import { AssignmentComponent } from './admin/assignment/assignment.component';
import { AddUsersComponent } from './admin/add-users/add-users.component';
import { FacilitiesComponent } from './admin/facilities/facilities.component';

const routes: Routes = [
  {path: '',   component: DashboardComponent },
  {path: 'dashboard',   component: DashboardComponent },
  {path: 'all-forms',   component: AllFormsComponent },
  {path: 'view-form',   component: ViewFormComponent },
  {path: 'view-submissions',   component: ViewSubmissionsComponent },
  {path: 'assignment',   component: AssignmentComponent },
  {path: 'add-users',   component: AddUsersComponent },
  {path: 'facilities',   component: FacilitiesComponent },




];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
